import { Sprite } from 'pixi.js';

import { Shared } from '../App';
import { defaultOpts, ShopIcon } from './ShopIcon';

const defOpts = {
    ...defaultOpts,
    anchor: { x: 0, y: 0.5 },
    tint: 0x000,
    selected: false,
    texture: '',
};

export type FlagIconOpts = typeof defaultOpts;

export class FlagIcon extends ShopIcon
{
    protected selectedSprite: Sprite;

    private _unlocked: boolean;
    private _selected: boolean;

    constructor(opts: Partial<FlagIconOpts> = {})
    {
        const o = { ...defOpts, ...opts };

        super(o);

        const offSet = 20;

        const flag = Sprite.from(Shared.assets.getTexture(o.texture));

        flag.anchor.set(0, 0.5);
        flag.scale.set(2);
        flag.x = offSet;

        flag.rotation = -Math.PI / 2;

        this.view.addChild(flag);

        this.selectedSprite = Sprite.from(Shared.assets.getTexture('equipped-tick'));
        this.selectedSprite.anchor.set(0, 1);
        this.selectedSprite.scale.set(1.5);
        this.selectedSprite.rotation = -Math.PI / 2;
        this.selectedSprite.x = o.size - (this.selectedSprite.width);
        this.selectedSprite.y = 0;
        this.view.addChild(this.selectedSprite);

        this._unlocked = o.unlocked;
        this._selected = o.selected;
    }

    public get state(): boolean { return this.active; }
    public set state(state: boolean)
    {
        this.active = state;
        this.view.texture = this.active ? this.activeTexture : this.inactiveTexture;
    }

    public get unlocked(): boolean { return this._unlocked; }
    public set unlocked(val: boolean)
    {
        this._unlocked = val;
    }

    public get selected(): boolean { return this._selected; }
    public set selected(val: boolean)
    {
        this._selected = val;

        this.selectedSprite.visible = val;
    }
}
